import React, { useEffect, useRef } from "react";
import { Layout } from "antd";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import routes from "../../routes";
import { useDispatch } from "react-redux";
import { getAuthToken, getCurrentUser } from "../../utils/authHelpers";
import { setUserType } from "../../features/Global/globalSlice";
import { get_organization } from "../../features/Organization/OrgAuth/OrgAuthSlice";
import Footer from "../../components/Footer/Footer";

const { Content } = Layout;

const AppContainer = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const token = getAuthToken();
  const location = useLocation();
  let currentUser = getCurrentUser();


  const hasFetchedData = useRef(false);

  useEffect(() => {
    if (hasFetchedData.current) return;
    hasFetchedData.current = true;

    if (token) {
      if (currentUser === 'organization') {
        dispatch(setUserType('organization'));
      }
      if (currentUser === 'employee') {
        dispatch(setUserType('employee'));
      }
    }
  }, [token, currentUser, dispatch, navigate]);

  const currentRoute = routes?.routes?.find(route => route.path === location.pathname);
  const showFooter = currentRoute?.footer;

  return (
    <Content
      className="site-layout-background"
    >
      <Routes>
        {routes.routes.map((list, index) => (
          <Route
            key={index}
            path={list.path}
            element={
              <Layout>
                {list.element}
              </Layout>
            }
          />
        ))}
      </Routes>
      {showFooter && <Footer />}
    </Content>
  );
};

export default AppContainer;
